export default (one, two) => one.toLowerCase() === two.toLowerCase();
